<script>
// definir un objeto mixin
export default {
  data() {
    return {
      valid: false,
      rules: {
        notRequired: (value) => true,
        required: (value) => !!value || "El campo es obligatorio.",
        requiredComboBox: (value) => (value != null && Object.prototype.hasOwnProperty.call(value, "id")) || "Debe seleccionar una opcion.",
        requiredComboBoxOnlyValue: (value) => value != null || "Debe seleccionar una opcion.",
        max3Length: (value) => value.length <= 3 || "El campo debe tener maximo 3 caracteres.",
        alphanumeric3: (value) => /^[a-zA-Z0-9]{1,3}$/.test(value) || "Debe tener maximo 3 caracteres alfanumericos.",
        numeric3: (value) => /^[0-9]{1,3}$/.test(value) || "Debe tener maximo 3 caracteres numericos.",
        max11Length: (value) => value.length <= 11 || "El campo debe tener maximo 11 caracteres.",
        noSpaces: (value) => !/\s/.test(value) || value == "" || value == null || "El campo no puede contener espacios.",
        email: (value) => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i.test(value) || value == "" || "El campo email no tiene un formato valido.",
        integer: (value) => /[0-9-]+/.test(value) || value == "" || "El campo debe ser numerico.",
        decimal: (value) => /[0-9-]+/.test(value) || value == null || value == "" || "El campo debe ser numerico.",
        max100Amount: value => (value <= 100) || 'La cantidad no debe ser mayor a 100.',
        onlySelectFromList: (value) => {
          if (value == null) return true;

          if (typeof value === "object") {
            if (Object.prototype.hasOwnProperty.call(value, "id")) {
              return true;
            }
            if (Object.prototype.hasOwnProperty.call(value, "name")) {
              return true;
            }
          }

          return "Debe seleccionar una opción del listado o deje el campo vacío.";
        },
        onlySelectFromListMultiple: (value) => {
          if (value == null || (Array.isArray(value) && value.length === 0)) return true;

          if (Array.isArray(value)) {
            for (let item of value) {
              if (typeof item !== "object") {
                return "Debe seleccionar opciones del listado o deje el campo vacío.";
              }
              if (!Object.prototype.hasOwnProperty.call(item, "id") && !Object.prototype.hasOwnProperty.call(item, "name")) {
                return "Debe seleccionar opciones del listado o deje el campo vacío.";
              }
            }
            return true;
          }

          return "Debe seleccionar opciones del listado o deje el campo vacío.";
        },
        requiredArray: (value) => (Array.isArray(value) && value.length > 0) || "Debe seleccionar al menos una opción.",
      },
    };
  },
  created: function () { },
  computed: {},
  mounted() { },
  methods: {},
};
</script>
